import { Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

interface DonutSlice {
  key: string;
  label: string;
  value: number;
  color: string;
}

export interface AllocationDonutProps {
  istSlices: DonutSlice[];
  sollSlices: DonutSlice[] | null;
  formatEur: (cents: number) => string;
  /** Klick auf einen Ist-Slice — fuer Drill-Down (key = SubKey/TopKey). */
  onSliceClick?: (key: string) => void;
}

export function AllocationDonut({
  istSlices,
  sollSlices,
  formatEur,
  onSliceClick,
}: AllocationDonutProps) {
  // Key auf das Daten-Objekt mappen, damit Recharts-onClick den Key liefert.
  const istData = istSlices.map((s) => ({
    name: s.label,
    value: s.value,
    fill: s.color,
    key: s.key,
  }));
  const sollData =
    sollSlices?.map((s) => ({ name: s.label, value: s.value, fill: s.color, key: s.key })) ?? null;

  // Recharts ruft onClick mit dem Daten-Payload — den eigenen "key" auslesen.
  const handleClick = onSliceClick
    ? (entry: unknown) => {
        if (
          entry &&
          typeof entry === "object" &&
          "key" in entry &&
          typeof (entry as { key: unknown }).key === "string"
        ) {
          onSliceClick((entry as { key: string }).key);
        }
      }
    : undefined;

  return (
    <div style={{ width: 320, height: 320 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          {sollData && (
            <Pie
              data={sollData}
              dataKey="value"
              nameKey="name"
              innerRadius={90}
              outerRadius={120}
              paddingAngle={1}
            />
          )}
          <Pie
            data={istData}
            dataKey="value"
            nameKey="name"
            innerRadius={50}
            outerRadius={85}
            paddingAngle={1}
            onClick={handleClick}
            cursor={onSliceClick ? "pointer" : undefined}
          />
          <Tooltip formatter={(v: number) => formatEur(v)} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
